import CoVSoundField from './CoVSoundField'

export default CoVSoundField
